document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.horizontal-slider-wrapper').forEach(wrapper => {
    const slider = wrapper.querySelector('.horizontal-slider');
    const next = wrapper.querySelector('.slider-arrow.next');
    const prev = wrapper.querySelector('.slider-arrow.prev');

    if (!slider) return;

    const scrollAmount = slider.clientWidth; // scroll exacto por "pantalla"

    next?.addEventListener('click', (e) => {
      e.preventDefault();
      slider.scrollLeft += scrollAmount;
    });

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      slider.scrollLeft -= scrollAmount;
    });
  });
});
